@for (preview of previewPages; track preview) {
    <div [class.active]="isActive(preview)"
         [class.mobile-view]="applicationStateService.currentViewMode.pagesToShow === 1"
         class="row preview-container grow">
        <div (click)="turnToPage(preview.pages, preview.id)"
             (keydown.enter)="turnToPage(preview.pages, preview.id)"
             (keydown.space)="$event.preventDefault(); turnToPage(preview.pages, preview.id)"
             role="button"
             tabindex="0"
        >
            @for (page of preview.pages; track page) {
                <div>
                    <sidebar-thumbnail-page-image [height]="height" [page]="page"
                                                  [width]="width"></sidebar-thumbnail-page-image>
                </div>
            }
        </div>
        <div>
            {{ getPreviewPageNumbers(preview.pages).join(' - ') }}
        </div>
    </div>
}